"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue } from "vue-property-decorator";
import API from "@ym-framework/api-utils";
import DateFormat from "@/framework/timeformatter";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import UiForm, { UiFormAnnotations, UiFormController } from "@/components/form/UiForm.vue";
import UiSubmit from "@/components/form/UiSubmit.vue";
import i18n from "@/lang";
import { Debounce } from "vue-debounce-decorator";
export class SafetyHandleForm extends UiFormController {
  constructor() {
    super(...arguments);
    this.statusStr = "pass";
    // public period_type:string = "forever";
    this.period_type = "interim";
    this.hours = 1;
    this.time_period_type = "unlimited";
    this.start_time = "";
    this.end_time = "";
    this.end_date = "";
  }
}
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: i18n.t("safetyhandledialog.please_select_permissions"),
    trigger: "blur"
  }])
], SafetyHandleForm.prototype, "statusStr", 2);
__decorateClass([
  UiFormAnnotations.Rule([{
    required: true,
    message: i18n.t("safetyhandledialog.please_select_the_authorization_period"),
    trigger: "blur"
  }])
], SafetyHandleForm.prototype, "period_type", 2);
let SafetyHandleDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.id = "";
    this.type = "new";
    this.infoData = null;
    this.pickerOptions = {
      disabledDate(time) {
        return time.getTime() <= Date.now() - 24 * 3600 * 1e3;
      }
    };
    this.dialogLoading = false;
    this.dialog = new UiDialogController();
    this.controller = new SafetyHandleForm();
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  submit() {
    return __async(this, null, function* () {
      try {
        if (this.type === "new") {
          const response = yield API.post(`api://base.auth/api/v7/handle`, {
            application_guid: this.infoData.applicationGuid,
            authorize: {
              period_type: this.controller.period_type,
              hours: this.controller.hours || 1,
              time_period_type: this.controller.time_period_type,
              start_time: this.controller.start_time,
              end_time: this.controller.end_time,
              end_date: this.controller.end_date
            },
            status: this.controller.statusStr
          });
        }
        if (this.type === "edit") {
          const response = yield API.put(`api://base.auth/api/v7/handle`, {
            guid: this.infoData.applicationGuid,
            authorize: {
              period_type: this.controller.period_type,
              hours: this.controller.hours || 1,
              time_period_type: this.controller.time_period_type,
              start_time: this.controller.start_time,
              end_time: this.controller.end_time,
              end_date: this.controller.end_date
            },
            status: this.controller.statusStr
          });
        }
        this.$message.success(this.$t("safetyhandledialog.operation_successful"));
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      } finally {
        this.close();
      }
    });
  }
  getSafetyInfo() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(`api://base.auth/api/v7/application/handle/${this.id}`);
        this.infoData = response.data;
        this.controller.statusStr = response.data.status || "pass";
        this.controller.period_type = response.data.authorize.period_type || "interim";
        this.controller.hours = response.data.authorize.hours || "";
        this.controller.time_period_type = response.data.authorize.time_period_type || "unlimited";
        this.controller.start_time = response.data.authorize.start_time || "";
        this.controller.end_time = response.data.authorize.end_time || "";
        this.controller.end_date = response.data.authorize.end_date || "";
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  getSafetyInfoByNew() {
    return __async(this, null, function* () {
      try {
        const response = yield API.get(`api://base.auth/api/v7/application/${this.id}`);
        this.infoData = response.data;
        this.controller.statusStr = response.data.status || "pass";
        this.controller.period_type = response.data.authorize.period_type || "interim";
        this.controller.hours = response.data.authorize.hours || 1;
        this.controller.time_period_type = response.data.authorize.time_period_type || "unlimited";
        this.controller.start_time = response.data.authorize.start_time || "";
        this.controller.end_time = response.data.authorize.end_time || "";
        this.controller.end_date = response.data.authorize.end_date || "";
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  open(id, type = "new") {
    this.id = id;
    this.type = type;
    this.controller = new SafetyHandleForm();
    if (type === "new") {
      this.getSafetyInfoByNew();
    }
    if (type === "edit") {
      this.getSafetyInfo();
    }
    this.dialog.visible = true;
  }
  close() {
    this.dialog.visible = false;
    this.$emit("refresh");
  }
  format_login_time(time) {
    if (time === 0 || time === null) {
      return "--";
    } else {
      return DateFormat.format_login_time(DateFormat.check(time));
    }
  }
};
__decorateClass([
  Debounce(800)
], SafetyHandleDialog.prototype, "submit", 1);
SafetyHandleDialog = __decorateClass([
  Component({
    components: {
      UiForm,
      UiSubmit,
      UiDialog
    }
  })
], SafetyHandleDialog);
export {
  SafetyHandleDialog as default
};
